import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

const subscribe = (callback) => {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", callback);
  return () => mq.removeEventListener("change", callback);
};

/** One-off read, for effects and event handlers. */
export const prefersReducedMotion = () => window.matchMedia(QUERY).matches;

/** Re-renders when the visitor's reduced-motion setting changes. */
export default function usePrefersReducedMotion() {
  return useSyncExternalStore(subscribe, prefersReducedMotion, () => false);
}
